import { createFileRoute } from "@tanstack/react-router";
import LegacyRoutes from "@/legacy-routes";

/**
 * Catch-all: every path TanStack Router has no route for renders the legacy
 * react-router tree, which then does its own matching.
 *
 * This is the strangler seam. Adding a real route file for a path makes that
 * route win over this splat, so screens can migrate one at a time with no
 * flag-flipping and no big-bang cutover.
 *
 * The two routers coexist because @tanstack/history monkey-patches
 * window.history.pushState/replaceState and notifies its subscribers. So when
 * react-router navigates, TanStack sees it and re-matches — without that, the
 * root router would go stale the moment legacy code called navigate().
 */
export const Route = createFileRoute("/$")({
  component: LegacyRoutes,
});
